import { render, staticRenderFns } from "./CatalogCategoryView.vue?vue&type=template&id=1628758e"
import script from "./CatalogCategoryView.vue?vue&type=script&lang=ts"
export * from "./CatalogCategoryView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports